import { render, staticRenderFns } from "./OrderDetailPage.vue?vue&type=template&id=537dd4fc&scoped=true"
import script from "./OrderDetailPage.vue?vue&type=script&lang=js"
export * from "./OrderDetailPage.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailPage.vue?vue&type=style&index=0&id=537dd4fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537dd4fc",
  null
  
)

export default component.exports